import {CompanyUnitEntity} from "@ots-frontend/ots-data";
import {BaseEntitySelect, BaseEntitySelectProps} from "../base-entity-select";

export type BaseCompanyUnitSelectProps = BaseEntitySelectProps<CompanyUnitEntity>;

export const BaseCompanyUnitSelect = (props: BaseCompanyUnitSelectProps) => {
  return <BaseEntitySelect {...props} />;
};
